import styled, { css } from 'styled-components'
import { theme, media } from '../../../../../../styles/_variables'


export const OptionLabel = styled.label`
width: 100%;
min-height: 160px;
@media only screen and (min-width: 375px) and (max-width: 768px) {
    min-height: 180px;
}
opacity: ${props => (props.disabled ? '0.5' : '1')};
> div{
    height: 100%;
    border-radius: 10px;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
}
> input{ /* HIDE RADIO */
    visibility: hidden; /* Makes input not-clickable */
    position: absolute; /* Remove input from document flow */
}
> input + div{ /* DIV STYLES */
    cursor:pointer;
    border:2px solid transparent;
}
> input:checked + div{ /* (RADIO CHECKED) DIV STYLES */
    font-weight: ${theme.fonts.style.semiBold}
    border: 5px solid rgba(${theme.color.primaryColorRGB}, 0.5) ;
    box-shadow: none;
}
`

export const OptionContentWrapper = styled.div`
display: grid;
align-content: center;
width: 100%;
padding: 16px 2px;
font-size: ${theme.fonts.size.subTitle};
color: ${theme.color.primaryColor}
text-align: center;
`

export const ImageDiv = styled.div`
 > img {
    width: fit-content;
    width: -moz-fit-content;
    width: auto;
    max-height: 90px;
    @media only screen and (min-width: 768px) and (max-width: 860px) {
        height: 80px;
    }
 }
`
export const Label = styled.div`
 font-size: ${theme.fonts.size.normal};
 margin-top: 8px;
 white-space: nowrap;
 color: ${theme.color.secondaryColor};
${media.mobileM`
    font-size: ${theme.fonts.size.small};
`}
@media only screen and (min-width: 768px) and (max-width: 860px) {
    font-size: ${theme.fonts.size.label};
  }
`

export default OptionLabel



// WEBPACK FOOTER //
// ./src/pages/package-page/detail/components/common/rectangle-option-item/styled.js